import Layout from '@layout/Index'

export const clbProduct = [
  {
    path: '/clb-product',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "clb-product-table" */ './pages/ClbProductTable.vue'),
        meta: {
          title: '查理任务产品列表',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "clb-product-form" */ './pages/ClbProductForm.vue'),
        meta: {
          title: '添加查理任务产品',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "clb-product-form" */ './pages/ClbProductForm.vue'),
        meta: {
          title: '修改查理任务产品',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "clb-product-detail" */ './pages/ClbProductDetail.vue'),
        meta: {
          title: '查理任务产品详情',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/clb-product/clb-product.route.js